import { getRootChannel } from 'utils/common';
import { channelModel } from 'common/api/models';

export const NAVIGATION_HOME_BUTTON_ID = -1;

/**
 * @param {navigationItemModel[]} navigationItems
 * @param {number} activeChannelId
 */
export const activateNavItemInTree = (navigationItems, activeChannelId) => {
  const rootChannel = getRootChannel(navigationItems);

  if (!activeChannelId) {
    rootChannel.active = true;
    return false;
  }

  const navItem = navigationItems.find((navItem) => navItem.id === activeChannelId);

  if (!navItem) {
    rootChannel.active = true;
    return false;
  }

  if (navItem.id === rootChannel.id) {
    navItem.active = false;
    return false;
  } else {
    navItem.active = true;
    activateNavItemInTree(navigationItems, navItem.parentId);
  }
};

/**
 * @param {channelModel[]|navigationItemModel[]} channels
 * @param {channelModel|navigationItemModel} channel
 * @param {{count:number}} _distanceFromRoot - consider private, shouldn't be provided as it is used only by recursion
 */
export const calcDistanceFromRootNode = (channels, channel, _distanceFromRoot = undefined) => {
  _distanceFromRoot = _distanceFromRoot || { count: 1 };
  let parent = channels.find((_channel) => _channel.id === channel.parentId);

  if (parent && parent.parentId !== -1) {
    _distanceFromRoot.count++;
    return calcDistanceFromRootNode(channels, parent, _distanceFromRoot);
  } else {
    return _distanceFromRoot.count;
  }
};

/**
 * Reduce channels nesting deepness to provided offset
 * Channels outside of provided offset will be removed
 *
 * @param {navigationItemModel[]|channelModel[]} channels
 * @param {number} offset - number of channels nesting levels
 */
export const channelsDeepnessLimit = (channels, offset = 3) => {
  return channels.filter((channel) => calcDistanceFromRootNode(channels, channel) <= offset);
};

/**
 * Link root channels to root channel
 *
 * @param channels
 */
export const addHomeChannel = (channels) => [
  ...channels,
  ...[
    {
      ...channelModel({
        id: NAVIGATION_HOME_BUTTON_ID,
        name: 'Home',
        slug: 'Home',
      }),
      parentId: null,
    },
  ],
];
